export default "__VITE_ASSET__b22f7f8b__"